import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0dfc04ad&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfc04ad')) {
      api.createRecord('0dfc04ad', component.options)
    } else {
      api.reload('0dfc04ad', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=0dfc04ad&", function () {
      api.rerender('0dfc04ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/App.vue"
export default component.exports